import Phaser from 'phaser';

export const DECOR_BASE_DEPTH = 5;

/**
 * Декоративный объект на «4-м плане» (depth=5) — между фоновыми силуэтами
 * (depth=-50) и игроком/платформами (depth=10).
 *
 * Origin (0.5, 1) — нижний центр привязан к точке размещения, чтобы было
 * удобно ставить на верхнюю кромку платформы или пол.
 *
 * Параметр `layer` — индивидуальный сдвиг порядка отрисовки внутри слоя
 * декора (для будущего редактора bring-forward / bring-backward). Не должен
 * выходить за пределы [-499..499], чтобы не пересечь depth player'а (10).
 * Реальный depth = DECOR_BASE_DEPTH + layer × 0.001.
 *
 * Объекты не имеют физики — игрок проходит сквозь, объекты могут наслаиваться
 * друг на друга в любом порядке.
 */
export class DecorItem extends Phaser.GameObjects.Image {
  public layer: number;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    key: string,
    scale = 1,
    layer = 0,
  ) {
    super(scene, x, y, key);
    scene.add.existing(this);
    this.setOrigin(0.5, 1);
    this.setScale(scale);
    this.layer = layer;
    this.setDepth(DECOR_BASE_DEPTH + layer * 0.001);
  }

  /** Сдвинуть на 1 уровень вперёд (выше остальных декораций). */
  bringForward(): void {
    this.layer += 1;
    this.setDepth(DECOR_BASE_DEPTH + this.layer * 0.001);
  }

  /** Сдвинуть на 1 уровень назад. */
  sendBackward(): void {
    this.layer -= 1;
    this.setDepth(DECOR_BASE_DEPTH + this.layer * 0.001);
  }

  /** Установить конкретный слой. */
  setLayer(layer: number): void {
    this.layer = layer;
    this.setDepth(DECOR_BASE_DEPTH + layer * 0.001);
  }
}
